import React, { FC, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import queryString from 'query-string';
import { Redirect } from 'react-router-dom';

import useAuth from '../useAuth';

/** when rendered, try to use the vromo access token shared via url as login */
const LoginForwarder: FC<RouteComponentProps> = ({ location }) => {

    const [redirect, setRedirect] = useState(false);
    const [login] = useAuth();

    const query = queryString.parse(location.search) || {};

    useEffect(() => {
        const { tok } = query;
        if (tok) {
            login(tok.toString()).finally(() => setRedirect(true));
        }
    }, []);

    const { next, url } = query;

    if (!redirect) {
        return null
    }
    if (next || url) {
        return <Redirect to={next ? next.toString() : url!.toString()} />;
    }
    else {
        return <Redirect to={'/'} />;

    }

}

export default LoginForwarder
